
  <dw-content>
    <form dw-form class="fx_modal_form">
      <div dw-row class="dw-f-table dw-f-row-bottom-margin">
      <dw-table #dwTable [dwData]="dataList" [dwShowPagination]="false" [dwFrontPagination]="false" [dwScroll]="{ y: '240px' }" dwSize="middle" >
        <thead dw-thead>
          <tr >
            <th dw-th style="width: 50%;">
              <span translate>com-常用条件名称</span>
            </th>
            <th dw-th style="width: 30%;">
              <span translate>com-默认查询条件</span>
            </th>
            <th dw-th style="width: 20%;">
              <span translate>com-操作</span>
            </th>
          </tr>
        </thead>
        <tbody dw-tbody>
          <tr dw-tbody-tr *ngFor="let data of dataList; let idx = index" [ngClass]="{active: data.isSelected}" (click)="selectItem(idx)">
            <td dw-td style="width: 50%;">
              <input dw-input [(ngModel)]="data.label" name="label{{idx}}" >
            </td>
            <td dw-td style="width: 30%; text-align:center;">
              <label dw-checkbox [(ngModel)]="data.aan005c" name="check{{idx}}"  (ngModelChange)="changeChecked(idx)">
              </label>
            </td>
            <td dw-td style="width: 20%;">
              <span class="dw-link-txt">
              <a translate (click)="delComCond(idx)" ><i class="anticon anticon-delete" ></i></a>
              </span>
            </td>
          </tr>
        </tbody>
      </dw-table>
    </div>
      <div class="customize-footer">
        <button dw-button (click)="sortUp()">{{ 'com-排序上移' | translate}}</button>
        <button dw-button (click)="sortDown()">{{ 'com-排序下移' | translate}}</button>
        <button dw-button type="button" [dwType]="'default'" (click)="handleCancel()">{{ 'dw-cancel' | translate}}</button>
        <button dw-button [dwType]="'primary'" (click)="handleOk()">{{ 'dw-save' | translate}}</button>
      </div>
    </form>
  </dw-content>
  